import { default_state } from "@/store/store.js";
import cloneDeep from "lodash/cloneDeep";
import veda from "../components/utils/veda";
import router from "../routes/router";

function reset_state(state, keys=null){
    if(!keys){
        keys = Object.keys(default_state);
    }
    for(let key of keys){
        state[key] = cloneDeep(default_state[key]);
    }
}

function set_investment_property_in_liability(state, application) {
  application.applicants.forEach((applicant, applicant_index) => {
    applicant.assets.forEach((asset, index) => {
      if (asset.type === "Investment Property") {
        state.selected_application.applicants[applicant_index].assets[index] = asset;
      }
    })
  })
}

function set_selected_pipeline_columns(state, columns) {
  state.selected_pipeline_columns = columns;
}

function set_selected_application(state, application){

    // TODO
    // apply transformations required to allow v-models to easily map onto the returned structure
    // that is, the returned structure matches the structure of our components

    // the UI v-models onto the first entry in phones, emails and identifications,
    // therefore the following will ensure at least entry exists for each type,
    // by adding a new blank entry to each empty array
    for(let applicant of application.applicants){

        // if noentry in emails array, create a default and add it into the array
        if(applicant.contact.emails.length == 0){
            applicant.contact.emails.push({ email: "" });
        }

        // if no entry in phone array, create a default and add it into the array
        if(applicant.contact.phones.length == 0){
            applicant.contact.phones.push({ type: "Mobile", phone_number: "" });
        }

        // if no entry in identifications array, create defaults License and passport and add it into the array
        if (applicant.personal_details.identifications.length === 0) {
            applicant.personal_details.identifications.push(
              {
                type: "License",
                id_number: null,
                card_number: null,
                issue_date: null,
                expiry_date: null,
                state_of_issue: null
              },
              {
                type: "Passport",
                id_number: null,
                card_number: null,
                issue_date: null,
                expiry_date: null,
                state_of_issue: null
              }
            );
        }

        // if just passport is provided , create a default License and add it into the array
        if (applicant.personal_details.identifications.length === 1
            && applicant.personal_details.identifications[0].type === 'Passport') {
              applicant.personal_details.identifications.unshift(
              {
                type: "License",
                id_number: null,
                card_number: null,
                issue_date: null,
                expiry_date: null,
                state_of_issue: null
              }
          );
        }

        // if just license is provided , create a default License and add it to end of array
        if (applicant.personal_details.identifications.length === 1
          && applicant.personal_details.identifications[0].type === 'License') {
            applicant.personal_details.identifications.push(
            {
              type: "Passport",
              id_number: null,
              card_number: null,
              issue_date: null,
              expiry_date: null,
              state_of_issue: null
            }
        );
      }

    }

    state.selected_application = application;
}

function setApplicationStatus(state, status){
    for(let [key, value] of Object.entries(status)){
        state.application_status[key] = value;
    }
}

function set_work_basket(state, applications){
    state.work_basket = applications;
}

function set_pagination(state, pagination){
  state.pagination = {
    ...state.pagination,
    per_page: pagination.per_page,
    page: pagination.page,
    total: pagination.total,
    backend_pagination: pagination.backend_pagination
  };
}

function set_auction_basket(state, { applications, subscribe_status, isBroker, isSuperAdmin, postcode, radius }) {
  state.auction_basket = {
    applications,
    subscribe_status,
    isBroker,
    isSuperAdmin,
    postcode,
    radius,
  };
}

function set_mql_auction_basket(state, { applications, subscribe_status, isBroker, isSuperAdmin, postcode, radius }) {
  state.mql_auction_basket = {
    applications,
    subscribe_status,
    isBroker,
    isSuperAdmin,
    postcode,
    radius,
  };
}

function set_distribution_basket(state, { applications, subscribe_status, isBroker, isSuperAdmin }) {
  state.distribution_basket = {
    applications,
    subscribe_status,
    isBroker,
    isSuperAdmin,
  };
}
function set_auction_lead_basket (state, { applications }) {
  state.auction_lead_basket = {
    applications,
  };
}

function set_application_search(state, { key, query, results }){
    state.application_search = {
        key,
        query,
        results,
    };
}

function set_types(state, { data }){
  // Only update options if data.options is non-empty and not null
  if (data.options && Object.keys(data.options).length > 0) {
    state.types.options = { ...state.types.options, ...data.options };
  }

  // Only update properties if data.properties is non-empty and not null
  if (data.properties && Object.keys(data.properties).length > 0) {
    state.types.properties = { ...state.types.properties, ...data.properties };
  }
}

function fetch_doc_templates(state, payload) {
    state.doc_templates = payload;
}

function fetch_document_types(state, payload) {
    state.document_types = payload;
}

function fetch_document_requests(state, payload) {
    state.document_requests = payload;
}

function set_administration_permissions(state, payload) {
    state.administration_permissions = payload;
}

function set_administration_roles(state, payload) {
    state.administration_roles = payload;
}

function set_administration_users(state, payload) {
    state.administration_users = payload;
}

function set_administration_pods(state, payload) {
    state.administration_pods = payload;
}

function set_administration_app_status_types(state, payload) {
  state.administration_app_status_types = payload;
}

function set_current_auction(state, payload) {
  state.auction = payload;
}

function set_administration_loan_asset_types(state, payload) {
  state.administration_loan_asset_types = payload;
}

function set_administration_brokers(state, payload) {
    state.administration_brokers = payload;
}

function set_administration_billings(state, payload) {
  state.administration_billings = payload;
}

function set_administration_introducers(state, payload) {
    state.administration_introducers = payload;
}

function set_administration_glass_prices(state, payload) {
    state.administration_glass_prices = payload;
}

function set_introducers(state, payload) {
  state.introducers = payload;
}

function set_user(state, payload) {
    state.user = payload;
}

function fetch_client_document_requests(state, payload) {
    state.document_requests = payload;
}

function set_administration_adjustments(state, payload) {
  state.administration_adjustments = payload;
}

function findWorstStatus(statuses, default_state = 'error', decisionEngineStatus = false) {
    let order = [
      'warning_greyed',
      'note',
      'accept',
      'warning',
      'decline',
      'error',
    ];
    let worst = default_state;
    let worst_index = -1;
    for (let status of statuses) {
      let index = order.indexOf(status);
      if (index > worst_index) {
        worst = status;
        worst_index = index;
      }
    }
    if(decisionEngineStatus) {
      //get unique status from statuses with their count
      let status_count = {};
      for (let status of statuses) {
        if (status_count[status]) {
          status_count[status]++;
        } else {
          status_count[status] = 1;
        }
      }
      //check if status_count array has only accept and warning as keys
      if (Object.keys(status_count).length == 2 && status_count.accept && status_count.warning) {
        //if there is only one warning return accept
        if (status_count.warning == 1) {
          return 'accept';
        }
      }
    }
    return worst;
}

function normalizeAssessmentDecisionEngines(decision_engines){
    for(let decision_engine of decision_engines) {
        let statuses = decision_engine.notes.map(n => n.status);
        statuses.push(decision_engine.status);
        decision_engine.status = findWorstStatus(statuses);
    }
}

// set advice order for each option
function setOptionsAdviceOrder(assessment) {

    // define sorting order based to on asset type
    let comparison = () => 0;
    switch (assessment.type) {
        case 'personal':
            comparison = (a, b) => parseFloat(b.total_income) - parseFloat(a.total_income);
            break;
        default:
            comparison = (a, b) => parseFloat(a.rate_max) - parseFloat(b.rate_max);
    }

    let sorted_options = [...assessment.options] // shallow copy to mitigate side effects
    sorted_options = sorted_options.sort(comparison);

    // resort by taken item from sorted in order where priority >= current index if possible, otherwise item with lowest priority value
    for (let destination_index = 0; sorted_options.length > 0; destination_index++) {

        // find index in sorted of first item where priority <= current index in priority_sorted
        let source_index = sorted_options.findIndex(item => item.priority <= destination_index);
        let item = null;
        let index = null;

        // if none found, select index in sorted of item with lowest priority
        if (source_index < 0) {
            let indexed_items = sorted_options.map((item, index) => [index, item]);
            [index, item] = indexed_items.reduce((a, b) => a[1].priority < b[1].priority ? b : a, indexed_items[0]);
        }

        // if still none found, select first
        // this should not occure, just in case
        if (source_index < 0) {
            console.error('prority sort failed, i=-1 encountered');
            source_index = 0;
        }

        // remove selected item from sorted and set order of item
        item = sorted_options.splice(source_index, 1)[0];
        item.advise_order = destination_index + 1;
    }
}

function set_assessment(state, assessment) {

    setOptionsAdviceOrder(assessment);
    normalizeAssessmentDecisionEngines(assessment.decision_engines);
    assessment.status = findWorstStatus(assessment.decision_engines.map( decision_engines => decision_engines.status ), 'loading', true);
    state.assessment = assessment;
}

function set_ml_assessment(state, ml_assessment) {
  normalizeAssessmentDecisionEngines(ml_assessment.decision_engines);
  ml_assessment.status = findWorstStatus(ml_assessment.decision_engines.map( decision_engines => decision_engines.status ), 'loading', true);
  state.ml_assessment = ml_assessment;
}

function set_veda_report(state, veda_report) {
  state.veda_report = veda_report;
}

function set_broker_postcode(state, broker_postcode) {
  state.broker_postcode = broker_postcode;
}

function set_broker_radius(state, broker_radius) {
  state.broker_radius = broker_radius;
}

function set_agent_has_visibility_subscription(state, agent_has_visibility_subscription) {
  state.agent_has_visibility_subscription = agent_has_visibility_subscription;
}

function set_cut_off_day(state, cut_off_day) {
  state.cut_off_day = cut_off_day;
}

function set_is_ram_authorized(state, is_ram_authorized) {
  state.is_ram_authorized = is_ram_authorized;
}

function set_audit_logs(state, applications){
    state.audit_logs = applications
}

function set_email_logs(state, applications){
  state.email_audit_logs = applications
}
function set_sms_logs(state, applications){
  state.sms_audit_logs = applications
}
function set_call_outcome_logs(state, logs){
  state.call_outcome_logs = logs
}

function set_updating_application(state, updating_application) {
  state.updating_application = updating_application
}

/**
 * @param {Object} state
 * @param state
 * @param data
 */
function set_reporting_meta_data_app_based(state, data) {
    state.reporting_meta_date_app_based = data;
}

/**
 * @param {Object} state
 * @param state
 * @param data
 */
function set_reporting_meta_data_settlement_based(state, data) {
  state.reporting_meta_date_settlement_based = data;
}

/**
 * @param {Object} state
 * @param state
 * @param data
 */
function set_pre_graph_data(state, data) {
    state.pre_graph_data = data;
}

/**
 * @param {Object} state
 * @param data
 */
function set_active_applications_graph_data(state, data) {
    state.active_apps_graph_data = data;
}

/**
 * get from algo driven server ppsrSearch
 *
 * @param state
 * @param payload
 * @constructor
 */
function FETCH_PPSR_SEARCH_RESULT(state, payload) {
  state.ppsr_search_results = payload;
}

/**
 * get from algo driven status update
 *
 * @param state
 * @param payload
 * @constructor
 */
function PPSR_STATUS_RESULT(state, payload) {
  state.ppsr_status_result = payload;
}

/**
 * set the billings to state
 * @param state
 * @param payload
 */
function set_billings(state, payload) {
  state.billings = payload;
}

function selected_bills(state, payload) {
  state.selected_bills = payload;
}

function set_warranty_billings(state, payload) {
  state.warranty_billings = payload;
}

function set_application_update_owners_dialog(state, application) {
    reset_state(state, 'application_update_owners_dialog');
    state.application_update_owners_dialog.application = application;
    state.application_update_owners_dialog.show = application != null;
}

function set_application_comment_dialog(state, application) {
    reset_state(state, 'application_comment_dialog');
    state.application_comment_dialog.application = application;
    state.application_comment_dialog.show = application != null;
}

function set_veda_summary_dialog(state, application_id) {
    reset_state(state, 'veda_summary_dialog');
    state.veda_summary_dialog.application_id = application_id;
    state.veda_summary_dialog.show = application_id != null;
}


function set_application_update_status_dialog(state, application) {
    reset_state(state, 'application_update_status_dialog');

    if(application){
        state.application_update_status_dialog.stage = application.status.stage;
        state.application_update_status_dialog.status = application.status.status;
        state.application_update_status_dialog.reason = application.status.reason;
        state.application_update_status_dialog.comment = application.status.comment;
    }

    state.application_update_status_dialog.send_email = false;
    state.application_update_status_dialog.email_body = "";
    state.application_update_status_dialog.application = application;
    state.application_update_status_dialog.show = application != null;
    console.log('set_application_update_status_dialog', {application, application_update_status_dialog:state.application_update_status_dialog});
}

function set_application_quick_response_dialog(state, application) {
  reset_state(state, 'application_quick_response_dialog');
  state.application_quick_response_dialog.application = application;
  state.application_quick_response_dialog.show = application != null;
}

function set_employment_directorship_dialogue(state, vedaEmployments) {
  reset_state(state, 'employment_directorship_dialog');
  //todo: remove this once signed off

  // state.employment_directorship_dialog.show = vedaEmployments != null;
  state.employment_directorship_dialog.show = false;
  state.employment_directorship_dialog.directorship = vedaEmployments;
}

function set_edit_user_profile_dialog(state, payload) {
  state.edit_user_profile_dialog = payload;
}

function application_referrer(state, owners) {
    if (owners) {
        let referrer = owners.find(owner => owner.role_name === 'Referrer');
        if (referrer !== undefined) {
            state.application_referrer.referrer = referrer["name"]["first_name"];
            state.application_referrer.commission.type = referrer["commission"]["type"];
            state.application_referrer.commission.rate = referrer["commission"]["rate"];
            state.application_referrer.is_marketing_lead = referrer["is_marketing_lead"];
            state.application_referrer.show = true;
        } else {
            state.application_referrer.referrer = null;
            state.application_referrer.commission.type = '';
            state.application_referrer.commission.rate = 0;
            state.application_referrer.is_marketing_lead = false;
            state.application_referrer.show = false;
        }
    } else {
        state.application_referrer.referrer = null;
        state.application_referrer.commission.type = '';
        state.application_referrer.commission.rate = 0;
        state.application_referrer.is_marketing_lead = false;
        state.application_referrer.show = false;
    }
}

function set_live_auction_previews(state, auctions) {
  state.live_auction_previews = auctions;
}

/**
 * this function is to extract directorship and personal details from veda report
 * and sets it in the applicant
 * @param {*} state
 * @param {*} applicant
 */
function prefillDataFromVeda(state, applicant) {
  if (applicant.veda_report && applicant.veda_report.user_details) {
    let vedaDetails = applicant.veda_report.user_details;

    // populate the field only if its previously empty if not do not replace it
    applicant.contact.gender = applicant.contact.gender ?? vedaDetails.gender;
    applicant.contact.date_of_birth = applicant.contact.date_of_birth ?? vedaDetails.date_of_birth;
    applicant.personal_details.identifications[0].id_number = applicant.personal_details.identifications[0].id_number ?? vedaDetails.driver_licence;

    let vedaEmployments = vedaDetails.directorships;
    if (vedaEmployments != '') {
      set_employment_directorship_dialogue(state, vedaEmployments)
    }
  }
}

function set_uploaded_documents(state, payload) {
  state.uploadedDocuments = payload;
}

/**
 * get from database record landTitleSearch
 *
 * @param state
 * @param payload
 * @constructor
 */
function set_land_title_search_result(state, payload) {
  state.land_title_search_results = payload;
}

/**
 * set make and check the model in the new model list
 *
 * @param state
 * @param payload
 */
function set_maker(state, payload) {
  state.makers = payload.make;
}

/**
 * set make and check the model in the new model list
 *
 * @param state
 * @param payload
 */
function set_all_maker(state, payload) {
  state.all_makers = payload.make;
}

/**
 * set model by year and make and check the model in the new model list
 *
 * @param state
 * @param payload
 */
function set_model(state, payload) {
  state.models = payload.model;
}

/**
 * set model by make and check the model in the new model list
 *
 * @param state
 * @param payload
 */
function set_model_make(state, payload) {
  state.models_make = payload.model;
}

/**
 * set model and maker to null
 *
 * @param state
 */
function clear_maker(state) {
  state.selected_application.loan.asset.vehicle.make = "";
  state.selected_application.loan.asset.vehicle.model = "";
}

/**
 * set model to null
 *
 * @param state
 */
function clear_model(state) {
  state.selected_application.loan.asset.vehicle.model = "";
}

/**
 * get glass data
 *
 * @param state
 * @param payload
 */
function set_glass(state, payload) {
  state.glasses = payload;
}

/**
 * set current applicant details from applicant 1 by detail_type
 *
 * @param state
 * @param payload
 */
function copy_from_applicant1(state, payload) {
    switch (payload.type) {
        case 'current_address':
            state.selected_application.applicants[payload.applicant_index].addresses.current.address = cloneDeep(state.selected_application.applicants[0].addresses.current.address);
            state.selected_application.applicants[payload.applicant_index].addresses.current.duration = cloneDeep(state.selected_application.applicants[0].addresses.current.duration);
            state.selected_application.applicants[payload.applicant_index].addresses.current.expense = cloneDeep(state.selected_application.applicants[0].addresses.current.expense);
            state.selected_application.applicants[payload.applicant_index].addresses.current.id = cloneDeep(state.selected_application.applicants[0].addresses.current.id);
            state.selected_application.applicants[payload.applicant_index].addresses.current.ownership = cloneDeep(state.selected_application.applicants[0].addresses.current.ownership);
            break;
        case 'previous_addresses':
            state.selected_application.applicants[payload.applicant_index].addresses.previous = cloneDeep(state.selected_application.applicants[0].addresses.previous);
            break;
        case 'landloard_details':
            state.selected_application.applicants[payload.applicant_index].addresses.current.landlord = cloneDeep(state.selected_application.applicants[0].addresses.current.landlord);
            break;
        case 'living_expenses':
            for (let expense of state.selected_application.applicants[0].expenses) {
                expense.amount = expense.amount / 2;
            }
            state.selected_application.applicants[payload.applicant_index].expenses = cloneDeep(state.selected_application.applicants[0].expenses);
            break;
        case 'assets_and_liabilities':
            state.selected_application.applicants[payload.applicant_index].assets = cloneDeep(state.selected_application.applicants[0].assets);
            break;
    }
}

/**
 * get and set the vehicle nvic, value, variant and series to getter
 *
 * @param state
 * @param payload
 */
function set_nvic_price(state, payload) {
  state.selected_application.loan.asset.vehicle.nvic = payload.nvic;
  state.selected_application.loan.asset.vehicle.value = payload.price;
  state.selected_application.loan.asset.vehicle.model_variant = payload.variant;
  state.selected_application.loan.asset.vehicle.model_series = payload.series;
  state.selected_application.loan.asset.vehicle.description =  payload.series + '; ' + payload.style + '; ' + payload.injection + '; ' + payload.transmission;
}

function redirect_after_save(state, application_data){
  let currentPathId = router.currentRoute.params.id;
  let applicationId = state.selected_application.loan.id;
  //if the current route id doesnt match the saved application id
  if(currentPathId != applicationId) {
    //change the router to have the application id in the url
    router.replace(`/application/${applicationId}/capture`);
  }
}

/**
 * function that sets the application status
 * @param state
 * @param payload
 */
function set_application_status(state, payload) {
  let appStatus = state.selected_application.loan.status;
  appStatus.comment = payload.comment;
  appStatus.reason = payload.reason;
  appStatus.stage = payload.stage;
  appStatus.status = payload.status;
}

/**
 * function that sets the application search
 * @param state
 * @param payload
 */
function set_advance_search_application(state, payload) {
  state.advance_search_application = payload;
}

/**
 * function that sets the lenders
 * @param state
 * @param payload
 */
function set_administration_lenders(state, payload) {
  state.administration_lenders = payload;
}

function set_owners(state, payload) {
  state.selected_application.owners = payload;
}

function set_administration_lenders_breakdown(state, payload) {
  state.administration_lenders_breakdown = payload;
}

function set_lead_requests(state, payload) {
  state.lead_requests = payload;
}

function set_lead_requests_forecasts(state, payload) {
  state.lead_requests_forecasts = payload; 
}

function set_pod_manager_status(state, isPodManager) {
  state.isPodManager = isPodManager;
}

function set_fin1_uploaded_document(state, payload) {
  state.fin1_uploaded_document = payload
}

/**
 * function sets the visibility for main drawer side component
 * @param state
 * @param payload
 */
function set_show_live_auction_drawer(state, payload) {
  state.show_live_auction_drawer = payload;
}

/**
 * function sets the submit to lender form visibility
 * @param state
 * @param payload
 */
function set_submit_to_lender_form_visibility(state, payload) {
    state.toggleSubmitToLenderForm = payload;
}

/**
 * set fields which are error in capture
 * @param state
 * @param payload
 */
function set_error_fields(state, payload) {
    state.error_fields = payload;
}

/**
 * sets the agents
 * @param state
 * @param payload
 */
function set_administration_agents(state, payload) {
    state.administration_agents = payload;
}

/**
 * sets the all types agents
 * @param state
 * @param payload
 */
function set_all_types_agents(state, payload) {
  state.all_types_agents = payload;
}

function swap_applicant_type(state, payload) {
  const arrayRef = state.selected_application.applicants;
  //swapping applicant type
  let tempApplicantType = arrayRef[payload].type;
  arrayRef[payload].type = arrayRef[0].type;
  arrayRef[0].type = tempApplicantType;
}

function set_application_lock_config(state, payload) {
    state.application_lock = payload;
}

function set_application_locks(state, payload) {
    state.application_locks = payload;
}

function set_current_lock(state, payload) {
  state.current_lock.messages = payload.messages;
  state.current_lock.app_id = payload.app_id;
}

function set_current_next_action(state, payload) {
  // Create or update the nextActionDate and nextAction for the specified applicationId
  state.nextActionDateData[payload.applicationId] = {
    nextActionDate: payload.nextActionDate,
    nextAction: payload.nextAction,
  };
}

function set_is_editing(state, payload) {
  state.is_editing = payload;
}

/**
 * set auction notification from pusher, include new auction id and auction count
 * @param {object} state
 * @param {array} payload
 */
function set_auction_notification(state, payload) {
  state.auction_notification = payload;
}

/**
 * Set last auction notification timestamp
 * @param {object} state
 * @param {number} payload
 */
function set_last_auction_notification_timestamp(state, payload) {
  state.last_auction_notification_timestamp = payload;
}

function set_hem_living_expense_access(state, payload) {
  state.hem_living_expense_access = payload;
}

function set_hem_living_expense(state, payload) {
  state.hem_living_expense = payload;
}

function set_preliminary_documents(state, preliminary_assessment_documents) {
  state.preliminary_assessment_documents = preliminary_assessment_documents.document;
}

export default {
    swap_applicant_type,
    set_selected_application,
    setApplicationStatus,
    set_work_basket,
    set_auction_basket,
    set_mql_auction_basket,
    set_distribution_basket,
    set_auction_lead_basket,
    set_all_types_agents,
    set_application_search,
    set_types,
    fetch_doc_templates,
    fetch_document_types,
    fetch_document_requests,
    set_administration_permissions,
    set_administration_roles,
    set_administration_users,
    set_administration_pods,
    set_administration_billings,
    set_user,
    fetch_client_document_requests,
    set_assessment,
    set_ml_assessment,
    set_audit_logs,
    set_administration_brokers,
    FETCH_PPSR_SEARCH_RESULT,
    PPSR_STATUS_RESULT,
    reset_state,
    set_billings,
    set_warranty_billings,
    set_application_update_owners_dialog,
    set_application_comment_dialog,
    set_application_update_status_dialog,
    set_application_quick_response_dialog,
    set_employment_directorship_dialogue,
    application_referrer,
    set_uploaded_documents,
    prefillDataFromVeda,
    set_land_title_search_result,
    set_administration_introducers,
    set_administration_glass_prices,
    set_introducers,
    set_maker,
    set_all_maker,
    set_model,
    set_model_make,
    set_glass,
    set_nvic_price,
    clear_maker,
    clear_model,
    redirect_after_save,
    set_application_status,
    selected_bills,
    set_advance_search_application,
    set_administration_loan_asset_types,
    set_administration_app_status_types,
    set_administration_lenders,
    set_reporting_meta_data_app_based,
    set_reporting_meta_data_settlement_based,
    set_pre_graph_data,
    set_owners,
    set_active_applications_graph_data,
    set_administration_lenders_breakdown,
    set_fin1_uploaded_document,
    set_submit_to_lender_form_visibility,
    set_error_fields,
    set_administration_agents,
    copy_from_applicant1,
    set_administration_adjustments,
    set_current_auction,
    set_veda_report,
    set_application_lock_config,
    set_application_locks,
    set_current_lock,
    set_is_editing,
    set_email_logs,
    set_sms_logs,
    set_call_outcome_logs,
    set_current_next_action,
    set_is_ram_authorized,
    set_broker_postcode,
    set_broker_radius,
    set_agent_has_visibility_subscription,
    set_edit_user_profile_dialog,
    set_investment_property_in_liability,
    set_cut_off_day,
    set_auction_notification,
    set_last_auction_notification_timestamp,
    set_lead_requests,
    set_lead_requests_forecasts,
    set_pod_manager_status,
    set_pagination,
    set_hem_living_expense_access,
    set_hem_living_expense,
    set_preliminary_documents,
    set_show_live_auction_drawer,
    set_live_auction_previews,
    set_veda_summary_dialog,
    set_updating_application,
    set_selected_pipeline_columns
}
